import type { RefObject } from 'react';
import { useEffect } from 'react';

const aoHost = process.env.REACT_APP_AO_URL || '';

export function useMessageListener(
  source: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handlers: Record<string, (payload: any) => void>
): void {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.source !== source) return;

      const messageType = event.data?.type;

      // Call the appropriate handler if it exists
      if (handlers[messageType]) {
        handlers[messageType](event.data.payload);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [source, handlers]);
}

export function sendMessage(
  ref: RefObject<HTMLIFrameElement>,
  type: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>
): void {
  if (ref.current && ref.current.contentWindow) {
    const message = {
      type,
      payload
    };

    ref.current.contentWindow.postMessage(message, aoHost);
  }
}
